import { Control, Controller, ControllerRenderProps } from 'react-hook-form';

import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import FieldInput, {
  INPUTABLE_FIELD_SCHEMA_TYPES,
} from 'dashboard/components-lib/FieldInput/FieldInput';
import FormGroup from 'dashboard/layouts/FormLayout/FormGroup';
import { FieldSchema } from 'lib/fields';

interface LabeledFormFieldInputProps {
  fieldSchema: FieldSchema;
  disabled: boolean;
  control: Control;
}

interface FieldGroupProps {
  name: string;
  id: string;
  label: string;
  control: Control;
  render: ({ field }: { field: ControllerRenderProps }) => React.ReactElement;
}

const FieldGroup = ({ name, id, label, control, render }: FieldGroupProps) => {
  return (
    <FormGroup>
      <FormControlLabel htmlFor={id}>{label}</FormControlLabel>
      <Controller name={name} control={control} render={render} />
    </FormGroup>
  );
};

const LabeledFormFieldInput = ({ fieldSchema, disabled, control }: LabeledFormFieldInputProps) => {
  const commonLabeledFormFieldInputProps = {
    name: `fields.${fieldSchema.key}`,
    id: `field_input.${fieldSchema.key}`,
    label: fieldSchema.label ?? fieldSchema.key,
    disabled: disabled,
    control: control,
  };
  const commonComponentProps = {
    id: `field_input.${fieldSchema.key}`,
    disabled: disabled,
  };
  if (!INPUTABLE_FIELD_SCHEMA_TYPES.includes(fieldSchema.type)) {
    return <></>;
  }
  return (
    <FieldGroup
      {...commonLabeledFormFieldInputProps}
      render={({ field: { value, onChange } }) => (
        <FieldInput
          {...commonComponentProps}
          fieldSchema={fieldSchema}
          value={value}
          onChange={onChange}
        />
      )}
    />
  );
};

export default LabeledFormFieldInput;
